import Component from '../core/Component'
import PositionObserver from '../meta/PositionObserver'
import Transitions from '../utils/Fx'
import withMedia from '../core/withMedia'

class Item extends Component {
    constructor(element) {
        super(element, {
            media: 'smallWideUp',
        })

        this.observer = null
        this.state = {
            active: false,
            position: 0,
        }
    }

    prepare() {
        this.observer = new PositionObserver(this.element, {
            onEnter: this.handleEnter,
            onLeave: this.handleLeave,
            onRender: this.handleRender,
            onBeforeResize: this.handleResize,
        })
    }

    destroy() {
        this.observer?.destroy()
        this.observer = null
    }

    handleEnter = () => {
        this.state.active = true
    }

    handleLeave = () => {
        this.state.active = false
    }

    handleResize = () => {
        this.resize()
    }

    handleRender = ({ ratio, velocityY }) => {
        if (!this.state.active) {
            return
        }

        this.element.style.transform = `translateX(${
            ratio < 0 ? Transitions.Sine(ratio) * this.state.position * 20 : 0
        }%)`
    }

    resize() {
        const box = this.element.getBoundingClientRect()
        this.state.position = box.left + box.width / 2 < window.innerWidth / 2 ? -1 : 1
    }
}

export default withMedia(Item)
